import numberFormatter from 'format-number';
import { isNumber, isUndefined } from '@anton.bobrov/react-hooks';
import { toNumber } from './toNumber.js';

function formatNumber(value, options) {
  let number = toNumber(value);
  if (isNumber(options?.fixed)) {
    number = toNumber(number.toFixed(options?.fixed));
  }
  const string = number.toString();
  let padRight = options?.padRight ?? options?.fixed;
  if (isUndefined(padRight)) {
    padRight = string.split(".")[1]?.length || 0;
  }
  const output = numberFormatter({
    ...options,
    integerSeparator: options?.integerSeparator ?? ",",
    padRight
  })(Math.abs(number));
  if (options?.hasSignPrefix || number < 0) {
    return `${number < 0 ? "-" : "+"}${output}`;
  }
  return `${output}`;
}

export { formatNumber };
//# sourceMappingURL=formatNumber.js.map
